
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Controlador as Model, ControladorInterfaz } from '../../../controlador';
    import * as Pedidos from '@/__env/lib/Ventas/Pedidos';
    import _ from 'lodash';
    import { Pedido } from '@/__env/lib/Ventas/Pedidos';
    import { Utiles } from '@/__env/pluggins/event-bus';
    import { Wait } from '@/__env/ext';
    @Component( {
        name: "Componente",
        props: {},
        components: {

        }
    } )
    export default class Componente extends Vue
    {

        @Prop()
        public Controlador: ControladorInterfaz;
        public get Pedido() { return this.Controlador.Pedido; }
        public get Estado() { return this.Controlador.Vista.Estado; }

        public Cargando: boolean = false;
        public Abrir: boolean = false;
        public get Ok(): boolean
        {
            return this.Pedido && this.Pedido.Tipo.esMercadoLibre && this.Pedido.IdExterna > 0;
        }

        public async Ejecutar()
        {
            if ( await Utiles.Mensajes.SiNo( 'Descargar nuevamente', 'Se descargarán todos los datos de la venta. Los cambios realizados se perderán. ¿Continuar?' ) )
            {
                this.Cargando = true;
                let e = await Pedido.DescargarVentaMercadoLibre( this.Pedido.Cuenta, this.Pedido.IdExterna );
                if ( e )
                {
                    Utiles.Notificaciones.Completado( 'Ordén descargada!' );
                    await Wait( 500 );
                    window.location.reload();
                } else
                {
                    Utiles.Notificaciones.Error( 'Ordén no encontrada' );
                }
                this.Cargando = false;
            }
        }
    }
